<template>
  <!-- # 5.3.2	债券发行情况 -->
  <el-container class="main_container w100">
    <el-main :class="{'ismobilePhone':isMobilePhone}">
      <div class="DataModule full_height">
        <el-row style="overflow-y: auto; height:100%;">
          <!-- Revised on 2022-03-05 -->
          <table id="table">
            <!-- Revised on 2022-03-05 -->
            <tr
              v-for="(value,key,index) in table_data"
              v-bind:key="index"
            >
              <td class="w20">{{row_keys[key]}}</td>
              <td class="w80">{{value}}</td>
            </tr>
          </table>
        </el-row>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import { get_issuance_status } from 'common/js/http/v3Api'
import { exportTableData } from 'common/js/utils/utils'

export default {
  name: "issuance_status",
  data() {
    return {
      row_keys: {
        // "a0":"发行人",
        // "a1":"发行起始日期",
        // "a2":"发行截止日期",
        // "a3":"上市日期",
        // "a4":"计划发行量(亿)",
        // "a5":"主承销商",
        // "a6":"副主承销商",
        // "a7":"主承金额分摊",
        // "a8":"承销团",
        // "a9":"承销方式",
        // "b0":"发行参考收益率(%)",
        // "b1":"网上发行日期",
        // "b2":"网上发行数量",
        // "b3":"招标方式",
        // "b4":"预案公告日期",
        // "b5":"发行公告日期",
        // "b6":"发行方式",
        // "b7":"缴款日期",
        // "b8":"实际发行量(亿)",
        // "b9":"发行费率(%)",
        // "c0":"招投标日期",
        // "c1":"招标标的",
        // "c2":"中标区间",
        // "c3":"认购倍数",
        // "c4":"同期债",
        // "c5":"网上发行日期V2",
        // "c6":"发行时债项评级",
        // "c7":"会计师事务所",
        // "c8":"募集资金用途",
        // "c9":"发行时主体评级",
        // "d0":"法律顾问"
       "a0": "issuer",
        "a1": "Starting date of issuance",
        "a2": "Cut-off date of issuance",
        "a3": "Listing date",
        "a4": "Planned issuance amount (100 mln yuan)",
        "a5": "Lead underwriter",
        "a6": "Co-lead underwriters",
        "a7": "Amount allocated to lead underwriter",
        "a8": "Underwriter syndicate",
        "a9": "Underwriting Mode ",
        "b0": "Reference yield at issuance (%)",
        "b1": "Online issuance date",
        "b2": "Amount of online issues",
        "b3": "Bidding method",
        "b4": "Planned date of announcement",
        "b5": "Date of announcement",
        "b6": "Distribution method",
        "b7": "Payment date",
        "b8": "Actual issuance amount (100 mln yuan)",
        "b9": "Issuance fee rate (%)",
        "c0": "Date of bidding",
        "c1": "Subject of tender",
        "c2": "Bid winning range",
        "c3": "Subscription multiple",
        "c4": "Contemporaneous debt",
        "c5": "Online issuance date V2",
        "c6": "Debt rating at issue",
        "c7": "accounting firm",
        "c8": "Purpose of raised funds",
        "c9": "Subject rating at issue",
        "d0": "Legal counsel"
      },
      isMobilePhone: false,
      stockCode: '120303.SH',
      table_data: {}
    };
  },

  mounted() {
    this.stockCode = this.$route.query.stockCode
    this.get_issuance_status()
  },
  methods: {
    async get_issuance_status() {
      const { data } = await get_issuance_status({
        trd_code: this.stockCode,
      });
      const rows = data.result.data.rows[0];
      this.table_data = rows
    },
    async searchTableData(item) {
      if (item) {
        this.stockCode = item;
        this.get_issuance_status()
      }
    },
    /* Revised on 2022-03-05  */
    exportTableData() {
      let html = document.getElementById("table").outerHTML.replace(/<(\w+) (.+?)>/g, (m, p1) => `<${p1}>`)
        .replace('<table>', '<table border>')
      // vnd.ms-excel.numberformat:@; 格式化文本
      // xmlns 和 head 中 用于显示网格线
      html = `<html xmlns:x="urn:schemas-microsoft-com:office:excel">
            <head>
              <xml>
                <x:ExcelWorkbook>
                  <x:ExcelWorksheets>
                    <x:ExcelWorksheet>
                      <x:WorksheetOptions>
                        <x:Print><x:ValidPrinterInfo /></x:Print>
                      </x:WorksheetOptions>
                    </x:ExcelWorksheet>
                  </x:ExcelWorksheets>
                </x:ExcelWorkbook>
              </xml>
            </head>
            <style>
              table{vnd.ms-excel.numberformat:@;}
            </style>
              ${html}
            </html>`
      let blob = new Blob([html], { type: 'application/octet-stream' })
      let url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.download = 'issuance_status.xlsx' // 重命名文件
      link.click()
      window.URL.revokeObjectURL(url) // 释放内存
    }
    /* Revised on 2022-03-05  */
  }
};
</script>

<style scoped>
.ismobilePhone {
  padding: 0 !important;
  background: #fff !important;
}
.bgw {
  background: #fff;
}
.w100 {
  width: 100%;
}
.el-main {
  padding: 0;
  height: 100%;
}

table {
  height: calc(100% - 30px);
  width: 100%;
  padding: 10px 0;
}
tr:nth-of-type(odd) {
  background-color: #f2f2f2;
}
tr:nth-of-type(even) {
  background-color: #ffffff;
}
td {
  text-indent: 10px;
  word-wrap: break-word !important;
  overflow: visible !important;
  white-space: normal !important;
  text-overflow: ellipsis;
  border: 0;
  border-right: 1px solid #cacaca;
  height: 32px;
}
.w20 {
  width: 25%;
}
.w80 {
  width: 75%;
}
</style>
